import React, { useState, useEffect } from "react";
import { Grid, Select, FormControl, MenuItem, Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../api";
import { useSelector } from "react-redux";

// Image for Sump Pump
import sumppump from "../../assets/Images/pump.png";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-1vh",
  },
  formControl: {
    width: "max-content",
    minWidth: "100%",
    backgroundColor: "#eeeef5",
    fontFamily: "Arial",
    height: "6vh",
  },
  paper1: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 10px #0123B421",
    opacity: "1",
    borderRadius: "12px",
    height: "15vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1vh 0",
  },
  cardHeading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#000000",
    marginTop: "1vh",
    fontWeight: "bold",
    fontSize: "1.7vh",
    textAlign: "center",
  },
  select: {
    fontWeight: "bold",
    height: "6vh",
    borderRadius: "0.8vw",
    fontFamily: "Arial",
    "& .MuiSvgIcon-root": {
      color: "white",
      backgroundColor: "#0123b4",
      borderRadius: "8px",
    },
     "& .MuiSelect-root": {
      marginTop: "-2vh",
    },
  },
  paper: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor: "#fcfafa",
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    borderRadius: "12px",
    opacity: "1",
  },
}));

export default function Eqp_Details() {
  const classes = useStyles();

  const [equipmentData, setEquipmentData] = useState({});
  const [selectedDevice, setSelectedDevice] = useState("");
  const [fdata, setFdata] = useState("all");
  const [fid, setFId] = useState("all");
  const [floor, setFloor] = useState([]);
  const zone_data = useSelector((state) => state.inDashboard.locationData);
  const buildingID = useSelector((state) => state.isLogged.data.building.id);

  useEffect(() => {
    // Sort floors
    const sortedZones = zone_data
      .filter((z) => z.zone_type === "GL_LOCATION_TYPE_FLOOR")
      .sort((a, b) => a.name.localeCompare(b.name));
    setFloor(sortedZones);

    api.floor
      .cpmGetDevData()
      .then((res) => {
        const sumpPumpOnly = {
          NONGL_SUMP_PUMP: res["NONGL_SUMP_PUMP"] || {},
        };
        setEquipmentData(sumpPumpOnly);
        setSelectedDevice("");
      })
      .catch(() => {
        setEquipmentData({ NONGL_SUMP_PUMP: {} });
      });
  }, [zone_data, buildingID]);

  const selectedType = "NONGL_SUMP_PUMP";

  const devices = equipmentData[selectedType]
    ? Object.entries(equipmentData[selectedType]).sort((a, b) =>
        a[1].name.localeCompare(b[1].name)
      )
    : [];

  const handleFloorChange = (name, id) => {
    setFId(id);
    setFdata(name);
    setSelectedDevice(id);
  };

  const typeImageMap = { NONGL_SUMP_PUMP: sumppump };

  const allowedParameters = {
    SUMP_Pmp_MOTOR_A_On_Off_SS: <>Run Status-<br />Motor A</>,
    SUMP_Pmp_MOTOR_B_On_Off_SS: <>Run Status-<br />Motor B</>,
    SUMP_Pmp_MOTOR_A_Trip_Alarm: <>Trip Status-<br />Motor A</>,
    SUMP_Pmp_MOTOR_B_Trip_SS: <>Trip Status-<br />Motor B</>,
  };

  const getDisplayName = (attrKey) => allowedParameters[attrKey] || attrKey.replace(/_/g, " ");

  const shouldShowParameter = (attrKey) => Object.keys(allowedParameters).includes(attrKey);

  const getTripStatusColor = (attrKey, val) => {
    if (attrKey === "SUMP_Pmp_MOTOR_A_Trip_Alarm" || attrKey === "SUMP_Pmp_MOTOR_B_Trip_SS") {
      return val === "1" || val === "active" || val === 1 || val === 2 || val === "2"? "red" : "green";
    }
    return "#0123B4";
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        {/* Floor Dropdown */}
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4} style={{ marginLeft: "1vw" }}>
            <FormControl variant="filled" size="small" className={classes.formControl}>
              <Select
                value={fdata}
                onChange={(e) => handleFloorChange(e.target.value, e.target.value)}
                disableUnderline
                className={classes.select}
              >
                <MenuItem value="all">All Floors</MenuItem>
                {floor.map((f) => (
                  <MenuItem key={f.uuid} value={f.name}>
                    {f.name || "-"}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* Device Cards */}
        <Grid container item xs={12} spacing={2} style={{ marginTop: "2vh" }}>
          {devices.length === 0 && (
            <Grid item xs={12}>
              <Card className={classes.paper} style={{ height: "44vh", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "2vh" }}>
                No Data Available
              </Card>
            </Grid>
          )}

          {devices
            .filter(([deviceId, deviceInfo]) =>
              fid === "all" ? true : deviceInfo?.Equipment_Group === fid
            )
            .map(([deviceId, deviceInfo]) => {
              const parameterOrder = Object.keys(allowedParameters);
              const filteredAttributes = deviceInfo?.Eqp_Attributes
                ? Object.entries(deviceInfo.Eqp_Attributes)
                    .filter(([attrKey]) => shouldShowParameter(attrKey))
                    .sort((a, b) => parameterOrder.indexOf(a[0]) - parameterOrder.indexOf(b[0]))
                : [];

              // If no attributes, show "-" card
              if (filteredAttributes.length === 0) {
                filteredAttributes.push(["-", { presentValue: "-" }]);
              }

              return (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} key={deviceId}>
                  <Card className={classes.paper} style={{ height: "44vh" }}>
                    <Grid container spacing={1} style={{ marginTop: "0.5vh" }}>
                      <Grid item xs={6} style={{ textAlign: "left", marginLeft: "2vh" }}>
                        <div style={{ color: "black", fontWeight: "bold", fontSize: "2.5vh", marginLeft: "2vh", whiteSpace: "normal", wordBreak: "break-word", lineHeight: "1.2", textAlign: "left" }}>
                          {deviceInfo.name || "-"}
                        </div>
                      </Grid>
                    </Grid>

                    <Grid container spacing={1} style={{ marginTop: "0.5vh" }}>
                      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                        <img src={typeImageMap[selectedType]} style={{ width: "10vw", height: "25vh", objectFit: "contain", marginTop: "3.5vh", marginLeft: "5vh" }} />
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6} xl={6} style={{ paddingRight: "0.5vw" }}>
                        <Grid container spacing={1}>
                          {filteredAttributes.map(([attrKey, attrValue]) => (
                            <Grid item xs={6} key={attrKey}>
                              <Card className={classes.paper1}>
                                <div className={classes.cardHeading}>{getDisplayName(attrKey)}</div>
                                <div style={{ fontSize: "2.5vh", color: getTripStatusColor(attrKey, attrValue?.presentValue), fontWeight: "bold", whiteSpace: "nowrap", marginBottom: "2vh" }}>
                                  {(() => {
                                    const val = attrValue?.presentValue;
                                    if (val === " " || val === undefined || val === null) return "-";
                                    if (attrKey === "SUMP_Pmp_MOTOR_A_On_Off_SS" || attrKey === "SUMP_Pmp_MOTOR_B_On_Off_SS") return val === "active" || val === 1 || val === "1" || val === 2 || val === "2" ? "ON" : "OFF";
                                    if (attrKey === "SUMP_Pmp_MOTOR_A_Trip_Alarm" || attrKey === "SUMP_Pmp_MOTOR_B_Trip_SS") return val === "active" || val === 1 || val === "1" ? "Tripped" : "Normal";
                                    return val;
                                  })()}
                                </div>
                              </Card>
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              );
            })}
        </Grid>
      </Grid>
    </div>
  );
}
